import { render, staticRenderFns } from "./PrizeList.vue?vue&type=template&id=e89ca856&"
import script from "./PrizeList.vue?vue&type=script&lang=js&"
export * from "./PrizeList.vue?vue&type=script&lang=js&"
import style0 from "./PrizeList.vue?vue&type=style&index=0&id=e89ca856&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports